<template>
  <div
    class="mdc-layout-grid__cell"
    :class="styleClasses"
  >
    <slot />
  </div>
</template>

<script>
import * as _ from 'lodash'

export default {
  name: 'MaterialGridCell',
  props: {
    cols: {
      type: Number,
      default: undefined
    },
    device: {
      type: String,
      default: ''
    },
    order: {
      type: Number,
      default: undefined
    },
    alignment: {
      type: String,
      default: ''
    },
    layout: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    advancedLayout () {
      return _.isEmpty(this.layout) === false
    },
    advancedLayoutClasses () {
      const classes = {}
      for (const layout of this.layout) {
        classes[`mdc-layout-grid__cell--span-${layout.columns}-${layout.device}`] = true
      }
      return classes
    },
    styleClasses () {
      return {
        // Optional, specifies the number of columns the cell spans
        [`mdc-layout-grid__cell--span-${this.cols}`]: this.cols >= 0,

        // Optional, specifies the number of columns the cell spans on a type of device (desktop, tablet, phone)
        [`mdc-layout-grid__cell--span-${this.cols}-${this.device}`]: this.cols >= 0 && !!this.device,

        // Optional, specifies the order of the cell
        [`mdc-layout-grid__cell--order-${this.order}`]: this.order >= 0,
        [`mdc-layout-grid__cell--align-${this.alignment}`]: !!this.alignment,
        ...this.advancedLayoutClasses
      }
    }
  }
}
</script>

<style lang="scss">
@import "./variables.scss";
@import "@material/layout-grid/mdc-layout-grid";
</style>
